import { render, staticRenderFns } from "./OperaHotCity.vue?vue&type=template&id=b5131bae&scoped=true"
import script from "./OperaHotCity.vue?vue&type=script&lang=js"
export * from "./OperaHotCity.vue?vue&type=script&lang=js"
import style0 from "./OperaHotCity.vue?vue&type=style&index=0&id=b5131bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5131bae",
  null
  
)

export default component.exports